module.exports = __webpack_public_path__ + "img/pasture_buffel_low.47448827.webp";